import axios from "axios";

export default {
    candidates(query) {
        return axios
            .get("/api/dashboard/candidates", {
                params: {
                    per_page: query.perPage,
                    current_page: query.currentPage,
                    page: query.page,
                    search: query.search
                }
            })
            .catch(error => {
                return error.response;
            });
    },

    exportUsers(query) {
        return axios
            .get("/api/dashboard/candidates/export", {
                responseType: "blob",
                params: {
                    search: query.search,
                    fields: query.fields
                }
            })
            .then(function (response) {
                return response;
            });
    },
    exportApplications(query) {
        return axios
            .get("/api/dashboard/applications/export", {
                responseType: "blob",
                params: {
                    search: query.search,
                    fields: query.fields
                }
            })
            .then(function (response) {
                return response;
            });
    },

    reminderStats(status) {
        return axios
            .get("/api/candidate/application/reminder/stats/" + status)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    attendantStats(status) {
        return axios
            .get("/api/candidate/application/attendant/stats/" + status)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    reminderTotalStats(status) {
        return axios
            .get("/api/candidate/application/reminder/total/stats/" + status)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    reminderEmployee(status, query) {
        return axios
            .get("/api/candidate/application/reminder/employee/" + status, {
                params: {
                    user: query.user,
                    year: query.year,
                    month: query.month,
                    school_type: query.school_type
                }
            })
            .catch(error => {
                return error.response;
            });
    },
    attendantEmployee(status, query) {
        return axios
            .get("/api/candidate/application/attendant/employee/" + status, {
                params: {
                    user: query.user,
                    year: query.year,
                    month: query.month
                }
            })
            .catch(error => {
                return error.response;
            });
    },
    exportReminder(status, query) {
        return axios
            .get(
                "/api/candidate/application/reminder/employee/" + status + "/export",
                {
                    responseType: "blob",
                    params: {
                        user: query.user,
                        year: query.year,
                        month: query.month,
                        school_type: query.school_type
                    }
                }
            )
            .then(function (response) {
                return response;
            });
    },
    exportAttendant(status, query) {
        return axios
            .get(
                "/api/candidate/application/attendant/employee/" + status + "/export",
                {
                    responseType: "blob",
                    params: {
                        user: query.user,
                        year: query.year,
                        month: query.month
                    }
                }
            )
            .then(function (response) {
                return response;
            });
    },
    employeeNotifications(query) {
        return axios
            .get("/api/dashboard/employee_notifications/", {
                params: {
                    processed: query.processed,
                    page: query.page,
                    per_page: query.perPage
                }
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    notifications(query) {
        return axios
            .get("/api/dashboard/notifications/", {
                params: {
                    processed: query.processed,
                    page: query.page,
                    per_page: query.perPage
                }
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    appointments(query) {
        return axios
            .get("/api/dashboard/appointments/", {
                params: {
                    staff: query.staff ? query.staff.id : null,
                    from: query.from,
                    to: query.to,
                    page: query.page,
                    per_page: query.perPage,
                    type: query.type,
                    dossier: query.dossier,
                    motivation: query.motivation
                }
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    exportAppointments(query) {
        return axios
            .get("/api/dashboard/appointments/export", {
                responseType: "blob",
                params: {
                    staff: query.staff ? query.staff.id : null,
                    from: query.from,
                    to: query.to,
                    type: query.type,
                    dossier: query.dossier,
                    motivation: query.motivation
                }
            })
            .then(function (response) {
                return response;
            });
    },
    getStaffWithAppointments(query) {
        return axios
            .get("/api/dashboard/staffs_with_appointments/", {
                params: {
                    from: query.from,
                    to: query.to,
                }
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    updateNotifications(data) {
        return axios
            .post("/api/dashboard/notifications/update", data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    messages(query) {
        return axios
            .get("/api/dashboard/messages/", {
                params: query
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    shopMessages(query) {
        return axios
            .get("/api/dashboard/shop_messages/", {
                params: query
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    unverifiedAccounts(query) {
        return axios
            .get("/api/dashboard/unverified_accounts", {
                params: {
                    per_page: query.perPage,
                    page: query.page,
                    count_only: query.countOnly,
                    search: query.search || undefined
                }
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    verifyAccount(userId) {
        return axios
            .post(`/api/dashboard/verify_account/${userId}`)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    resendVerification(email) {
        return axios
            .post('/api/auth/resend-verification', { email })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    bulkResendVerification(emails) {
        return axios
            .post('/api/dashboard/unverified_accounts/bulk_resend', { emails })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    bulkVerifyAccounts(userIds) {
        return axios
            .post('/api/dashboard/unverified_accounts/bulk_verify', { user_ids: userIds })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    exportUnverifiedAccounts() {
        return axios
            .get('/api/dashboard/unverified_accounts/export', { responseType: 'blob' })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'comptes_non_verifies_' + new Date().toISOString().slice(0, 10) + '.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    bulkDeleteAccounts(userIds) {
        return axios
            .post('/api/dashboard/unverified_accounts/bulk_delete', { user_ids: userIds })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    }
};
